import { useFormikContext } from "formik";
import React, { FC } from "react";
import { CustomFieldBuilder } from "../../../containers/utilities/CustomFieldBuilder";
import { useLocale } from "../../../contexts/localeContext";
import { TranslationKeys } from "../../../contexts/TranslationKeys";
import { DynamicFieldDescriptor } from "../../../models/DynamicFieldDescriptor";

interface PresetMultiSelectProps {
    onNext: (event: React.MouseEvent<HTMLButtonElement>) => void;
    onBack: (event: React.MouseEvent<HTMLButtonElement>) => void;
    field: DynamicFieldDescriptor;
    setSideBarStepDescription: (newDescription: string) => void;
}

const PresetMultiSelect: FC<PresetMultiSelectProps> = ({ onNext, onBack, field, setSideBarStepDescription }) => {
    const { translate } = useLocale();
    const formik = useFormikContext<any>();
    const customFieldBuilder: CustomFieldBuilder = new CustomFieldBuilder(formik, translate);

    const createFields = () => {
        return [field].reduce((formFields, item) => {
            return customFieldBuilder.buildFormField(formFields, item, false, true, undefined)
        }, new Array(0)).map(fieldBundle => fieldBundle.map(field => field.content))
    }

    const getSelectionCount = () => {
        const fieldValue = formik.values.custom?.[field.systemName]?.value;
        return Array.isArray(fieldValue) ? fieldValue.length : 0;
    }

    const selectionCount = getSelectionCount();
    const onLocalNext = (e: React.MouseEvent<HTMLButtonElement>) => {
        const description = translate.byKeyFormatted(TranslationKeys.selectedWithCount, { count: selectionCount });
        setSideBarStepDescription(description);
        onNext(e);
    }

    return <div className="flex flex-col pt-3 pr-3 h-full relative">
        <div className="flex flex-col overflow-y-auto" style={{ height: '85%' }}>
            <div className="flex flex-col pt-3">
                {createFields()}
            </div>
        </div>
        <div className="flex flex-row justify-end absolute bottom-0 right-0 pr-3 pb-3 ">
            <div className="flex flex-row mt-4">
                <button
                    className={`secondary secondary-inverse py-1 px-5`}
                    type="button"
                    onClick={onBack}>{translate.byKey(TranslationKeys.back)}</button>
            </div>
            <div className="flex flex-row justify-end mt-4 pl-3">
                <button
                    className={`py-1 px-5 secondary ${selectionCount <= 0 && field.isRequired ? 'secondary-disabled cursor-not-allowed' : 'secondary-enabled'} `}
                    type='button'
                    disabled={selectionCount <= 0 && field.isRequired}
                    onClick={onLocalNext}>{translate.byKey(TranslationKeys.next)}</button>
            </div>
        </div>
    </div>
}

export default PresetMultiSelect;